export default {"src":"/_next/static/media/customer_support.5aac1023.svg","height":36,"width":46,"blurWidth":0,"blurHeight":0};